/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const NoseDefault = ({
  className,
  noseDefault = "/img/nose-default.svg",
}) => {
  return (
    <img
      className={`nose-default ${className}`}
      alt="Nose default"
      src={noseDefault}
    />
  );
};

NoseDefault.propTypes = {
  noseDefault: PropTypes.string,
};
